import React from 'react';

const DashHeader = () => {
  return (
    <header className="bg-gray-800 ">
      <div className="container mx-[60px] ">
        <div className="flex items-center justify-between h-16">
          <div className='flex item-baseline'>
            <img className="h-[150px] w-[150px]" src="/citylogo.png" alt="Logo" />
          </div>
          <div className="flex items-center">
            <div className="hidden md:block">
              <div className="flex items-baseline space-x-4">
                <a href="h" className="text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium">Dashboard</a>
                <a href="k" className="text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium">Reports</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default DashHeader;